module.exports = __webpack_public_path__ + "static/media/long-12.120e6a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/long/long-12.png
// module id = 2136
// module chunks = 0